import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, adminOnly = false }) {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  // Se não houver token, redireciona para o login
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Se a rota for apenas para administradores e o usuário não for admin, redireciona para a página de palpites
  if (adminOnly && userRole !== 'administrator') {
    return <Navigate to="/predictions" replace />;
  }

  return children;
}

// 🛠 Correção: validação das props
ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  adminOnly: PropTypes.bool,
};

export default ProtectedRoute;
